module.exports = __webpack_public_path__ + "img/offshore-oil-rig.97589b48.jpg";